import { gql } from '@apollo/client';

export const GET_LINKED_ACCOUNTS = gql`
  query getLinkedAccounts {
    profile {
      linkedAccounts {
        userId
        email
        hierarchy {
          id
          type
          name
        }
        scopes
      }
    }
  }
`;
